import * as React from 'react'

import uniq from 'lodash/uniq'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import applicationPhases from 'modules/ats/store/collections/applicationPhases'
import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'

interface Props {
  forms: ArgumentForm[]
}

const PhaseSelector = ({ forms }: Props) => {
  const [loading, setLoading] = React.useState(true)
  React.useEffect(() => {
    const loadData = async () => {
      await applicationPhases.fetch()
      setLoading(false)
    }

    loadData()
  }, [])

  const options = () => {
    const phases = uniq(applicationPhases.map((phase) => phase.attributes.name))

    return phases.map((phase) => {
      return {
        value: phase,
        label: phase,
      }
    })
  }

  if (loading) return null // No loading component

  const form = forms[0]

  return (
    form && (
      <FormRow>
        <Select
          none={i18n.t('custom_reports.especial_filters.ats_application_phase.none')}
          label={i18n.t('custom_reports.especial_filters.ats_application_phase.label')}
          field={form.get('value')}
          options={options()}
        />
      </FormRow>
    )
  )
}

export default PhaseSelector
